import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loader-progress',
  templateUrl: './app-loader-progress.component.html',
  styleUrls: ['./app-loader-progress.component.css']
})
export class AppLoaderProgressComponent implements OnInit {
  title;
  message;
  finished = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  public value = 0;
  constructor(public dialogRef: MatDialogRef<AppLoaderProgressComponent>) {}

  ngOnInit() {
  }

  public close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

}
